import { fi } from "date-fns/locale";
import React, { useState, useEffect } from "react";

type ClientsResponse = {
  clients: Record<string, { overall_status?: string }>;
};

type Server = {
  id: number;
  name: string;
  status: string;
  displayName: string;
};

const ServerTable = ({ envName, data, loading, returnMessage }: { envName: string; data: any; loading: boolean; returnMessage?: any }) => {

  const [serverName, setServerName] = useState(envName);
  const [servers, setServers] = useState<Server[]>([]);
  const [activeServerId, setActiveServerId] = useState<number | null>(null);

  const handleServerUp = async (env: string, name: string, id: number) => {
    setActiveServerId(id); // reset message before API call
    try {
      const response = await fetch(
        `https://opltpq2hn9.execute-api.us-east-1.amazonaws.com/${env}/start?client=${name}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // check if API failed (400, 500 etc.)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      console.log("API Response:", data);
      returnMessage(data.message || ""); // update state with API response
      // alert(data.message || "No message received");

    } catch (error) {
      console.error("API error:", error);
    } finally {
      setActiveServerId(null); // reset message after API call completes
    }
  };


  useEffect(() => {
    setServerName(envName);
    setServers(data);
  }, [data]);

  return (
    <>
      <table className="min-w-full border-2 border-gray-300 text-center mb-6">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-4 py-2">{serverName} Client</th>
            <th className="border px-4 py-2">Server Status</th>
            <th className="border px-4 py-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan={3} className="border px-4 py-2 text-center">
                <div className="flex justify-center items-center py-6">
                  Loading . . .
                  <div className="ml-2 h-6 w-6 animate-spin rounded-full border-2 border-blue-500 border-t-transparent"></div>
                </div>
              </td>
            </tr>
          )}
          {!loading && servers.map((server) => (
            <tr key={server.id} className="hover:bg-gray-50">
              <td className="border px-4 py-2 capitalize">{server.displayName}</td>
              <td className="border px-4 py-2">
                <span
                  className={`font-semibold rounded-xl px-3 py-1 ${server.status === "Running"
                    ? "text-green-800 bg-green-300"
                    : "text-red-700 bg-pink-100"
                    }`}
                >
                  {server.status}
                </span>
              </td>
              <td className="border px-4 py-2">
                <button
                  onClick={() => handleServerUp(serverName.toLowerCase(), server.name, server.id)}
                  disabled={server.status === "Running"}
                  className={`px-4 py-2 rounded text-white ${server.status !== "Running"
                    ? "bg-blue-500 hover:bg-blue-600"
                    : "bg-gray-400 cursor-not-allowed"
                    }`}
                >
                  <div className="flex justify-center items-center">
                    Start {activeServerId === server.id && <div className="ml-2 h-3 w-3 animate-spin rounded-full border-2 border-white-500 border-t-transparent"></div>}
                  </div>
                </button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default ServerTable;